import { Controller } from "@hotwired/stimulus"
import * as Routes from "routes"

export default class extends Controller {
  dismiss(event) {
    if (!event.target.closest('[data-dismiss="alert"]')) return

    fetch(Routes.ispm_early_access_banner_dismissed_account_path(), {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content }
    })
  }
}
